module.exports = __webpack_public_path__ + "static/media/metafest-manifest-the-future.a1540c87.png";